import React, { useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import PRofileID from "../../../../helper/svg/ID.svg";
import Smartphone from "../../../../helper/svg/smartphone.svg";
import Avtar from "../../../../helper/images/Avtar.png";
import { TbMailFilled } from "react-icons/tb";
import { FaLocationDot } from "react-icons/fa6";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { IoStarSharp } from "react-icons/io5";
import Userdoc from "../../../../helper/images/userdoc.png";
import Resto1 from "../../../../helper/images/offerimage.png";
import { RiImageAddFill } from "react-icons/ri";
import { getOfferById, updateOfferStatus } from "../../../../api/admin/offers";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import { IoStar, IoStarOutlined } from "react-icons/io";
import { MdStar, MdStarHalf, MdStarOutline } from "react-icons/md";
import { useTranslation } from "../../../../hooks/useTranslation";
const PromotionDetail = () => {
  const { t } = useTranslation();
  const { offerId } = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ["offer", offerId],
    queryFn: () => getOfferById(offerId),
    enabled: !!offerId,
  });

  const statusMutation = useMutation({
    mutationFn: (payload) => updateOfferStatus(offerId, payload),
    onSuccess: () => {
      const successMessage = t("hotedetailpromotionDetail").toastMessages?.statusUpdated || "Offer status updated";
      toast.success(successMessage);
      queryClient.invalidateQueries(["offer", offerId]);
    },
    onError: () => {
      const errorMessage = t("hotedetailpromotionDetail").toastMessages?.statusUpdateError || "Failed to update status";
      toast.error(errorMessage);
    },
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  const offer = data?.data;

  const handleApprove = () => {
    Swal.fire({
      title: t("hotedetailpromotionDetail").confirmDialog?.approveTitle || "Are you sure you want to approve?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("hotedetailpromotionDetail").confirmDialog?.yes || "Yes",
      cancelButtonText: t("hotedetailpromotionDetail").confirmDialog?.no || "No",
    }).then((result) => {
      if (result.isConfirmed) {
        statusMutation.mutate({
          status: "approved",
        });
      }
    });
  };

  const handleReject = () => {
    Swal.fire({
      title: t("hotedetailpromotionDetail").confirmDialog?.rejectTitle || "Are you sure you want to reject?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("hotedetailpromotionDetail").confirmDialog?.yes || "Yes",
      cancelButtonText: t("hotedetailpromotionDetail").confirmDialog?.no || "No",
    }).then((result) => {
      if (result.isConfirmed) {
        statusMutation.mutate({
          status: "rejected",
        });
      }
    });
  };

  return (
    <>
      <div className="flex gap-[10px] items-center">
        <div
          onClick={() => navigate(-1)}
          className="w-[32px] h-[32px] bg-[#4CAF50] rounded-[50%] flex items-center justify-center hover:bg-[#FF9D00] cursor-pointer"
        >
          <IoIosArrowRoundBack size={24} className="text-[#fff]" />
        </div>
        <h2 className="lg:text-[22px] text-lg font-medium">
          {offer?.hotel
            ? t("hotedetailpromotionDetail").Hotel
            : t("hotedetailpromotionDetail").Restaurant}{" "}
          {t("hotedetailpromotionDetail").title}
        </h2>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-[1fr_360px] gap-[30px] mt-[30px]">
        <div className="2xl:p-[38px] lg:p-[25px] p-[15px] border border-[#DDDDDD] rounded-[10px] bg-[#fff] -full">
          {offer?.hotel && (
            <div className="flex justify-between flex-wrap gap-[30px] mt-[16px] pb-[23px] border-b border-[#D9D9D9] items-center">
              <div>
                <h2 className="text-[30px] font-semibold mb-[10px]">
                  {offer?.hotel.name}
                </h2>
                <p className="text-lg mb-[18px]">{offer?.hotel?.address}</p>
                <div className="flex items-center gap-[29px]">
                  <p className="text-lg font-medium">
                    {t("hotedetailpromotionDetail").reviews}
                    {offer?.hotel?.rating} / 5
                  </p>
                  <div className="flex items-center gap-[2px]">
                    {Array(Math.floor(offer?.hotel?.rating))
                      .fill()
                      .map((_, index) => (
                        <MdStar
                          key={`full-${index}`}
                          size={21}
                          className="text-[#FF9D00]"
                        />
                      ))}

                    {offer?.hotel?.rating % 1 !== 0 && (
                      <MdStarHalf size={21} className="text-[#FF9D00]" />
                    )}

                    {Array(5 - Math.ceil(offer?.hotel?.rating))
                      .fill()
                      .map((_, index) => (
                        <MdStarOutline
                          key={`empty-${index}`}
                          size={21}
                          className="text-[#FF9D00]"
                        />
                      ))}
                  </div>
                </div>
              </div>
              {offer?.status === "pending" && (
                <div className="lg:text-right lg:justify-end flex gap-[20px] flex-col sm:w-auto w-full">
                  <Link
                    to="#"
                    onClick={handleApprove}
                    className="inline-block sm:max-w-[238px] sm:ml-auto w-full rounded-[2px] bg-[#4CAF50] 2xl:text-[20px] text-base text-white text-center font-bold 2xl:p-[14px] p-3 green-shadow hover:bg-[#209b25]"
                  >
                    {t("hotedetailpromotionDetail").buttons?.approveOffer || "Approve Offer"}
                  </Link>

                  <Link
                    to="#"
                    onClick={handleReject}
                    className="inline-block w-full sm:max-w-[238px] sm:ml-auto rounded-[2px] bg-[#FF0000] 2xl:text-[20px] text-base text-white text-center font-bold 2xl:p-[14px] p-3 red-shadow hover:bg-[#D62323]"
                  >
                    {t("hotedetailpromotionDetail").buttons?.rejectOffer || "Reject Offer"}
                  </Link>
                </div>
              )}
            </div>
          )}

          {offer?.restaurant && (
            <div className="flex justify-between flex-wrap gap-[30px] mt-[16px] pb-[23px] border-b border-[#D9D9D9] items-center">
              <div>
                <h2 className="text-[30px] font-semibold mb-[10px]">
                  {offer?.restaurant?.name}
                </h2>
                <p className="text-lg mb-[18px]">
                  {offer?.restaurant?.address}
                </p>
                <div className="flex items-center gap-[29px]">
                  <p className="text-lg font-medium">
                    Reviews {offer?.restaurant?.rating} / 5
                  </p>
                  <div className="flex items-center gap-[2px]">
                    {Array(Math.floor(offer?.restaurant?.rating))
                      .fill()
                      .map((_, index) => (
                        <MdStar
                          key={`full-${index}`}
                          size={21}
                          className="text-[#FF9D00]"
                        />
                      ))}

                    {offer?.restaurant?.rating % 1 !== 0 && (
                      <MdStarHalf size={21} className="text-[#FF9D00]" />
                    )}

                    {Array(5 - Math.ceil(offer?.restaurant?.rating))
                      .fill()
                      .map((_, index) => (
                        <MdStarOutline
                          key={`empty-${index}`}
                          size={21}
                          className="text-[#FF9D00]"
                        />
                      ))}
                  </div>
                </div>
              </div>
              {offer?.status === "pending" && (
                <div className="lg:text-right lg:justify-end flex gap-[20px] flex-col sm:w-auto w-full">
                  <Link
                    to="#"
                    onClick={handleApprove}
                    className="inline-block sm:max-w-[238px] sm:ml-auto w-full rounded-[2px] bg-[#4CAF50] 2xl:text-[20px] text-base text-white text-center font-bold 2xl:p-[14px] p-3 green-shadow hover:bg-[#209b25]"
                  >
                    {t("hotedetailpromotionDetail").buttons?.approveOffer || "Approve Offer"}
                  </Link>

                  <Link
                    to="#"
                    onClick={handleReject}
                    className="inline-block w-full sm:max-w-[238px] sm:ml-auto rounded-[2px] bg-[#FF0000] 2xl:text-[20px] text-base text-white text-center font-bold 2xl:p-[14px] p-3 red-shadow hover:bg-[#D62323]"
                  >
                    {t("hotedetailpromotionDetail").buttons?.rejectOffer || "Reject Offer"}
                  </Link>
                </div>
              )}
            </div>
          )}

          <div className="grid grid-cols-1 lg:grid-cols-2 md:gap-[25px] gap-[10px] mt-[21px] pb-[30px]">
            <div>
              <h3 className="text-lg font-medium">
                {t("hotedetailpromotionDetail").offerDetails.offerTitle}
              </h3>
              <p className="text-[#3E3E3E] text-base mt-[10px]">
                {offer?.title}
              </p>
            </div>
            <div>
              <h3 className="text-lg font-medium">
                {t("hotedetailpromotionDetail").offerDetails.discountRate}
              </h3>
              <p className="text-[#3E3E3E] text-base mt-[10px]">
                {offer?.discountPercentage}%
              </p>
            </div>
            <div>
              <h3 className="text-lg font-medium">
                {t("hotedetailpromotionDetail").offerDetails.description}
              </h3>
              <p className="text-[#3E3E3E] text-base mt-[10px]">
                {offer?.description}
              </p>
            </div>
            <div>
              <h3 className="text-lg font-medium">
                {t("hotedetailpromotionDetail").offerDetails.duration}
              </h3>
              <p className="text-[#3E3E3E] text-base mt-[10px]">
                {new Date(offer.startDate).toLocaleDateString()} -{" "}
                {new Date(offer.endDate).toLocaleDateString()}
              </p>
            </div>
          </div>

          <div className="p-[20px] border border-[#D9D9D9] rounded-[10px] bg-[#fff] ">
            <h3 className="text-lg font-medium">
              {t("hotedetailpromotionDetail").offerDetails.offerImages}
            </h3>
            <div className="flex gap-[14px] flex-wrap mt-[21px]">
              <img
                src={offer?.image ? `${offer?.image}` : Resto1}
                alt=""
                className=""
              />
            </div>
          </div>
        </div>
        <div>
          <div className="w-full xl:max-w-[360px] border border-[#DDDDDD] rounded-[12px] bg-white p-2">
            <div className="bg-[#FFFAF2] h-[132px] rounded-[3.56px]"></div>
            <img
              src={
                offer?.addedBy?.profilePicture
                  ? `${offer?.addedBy?.profilePicture}`
                  : Avtar
              }
              alt=""
              className="w-full max-w-[159px] h-[159px] mx-auto rounded-full border-4 border-white -mt-[80px]"
            />
            <h2 className="text-xl font-medium text-[#353535] text-center mt-5">
              {offer?.addedBy?.name}
            </h2>
            <div className="bg-[#E1EDDE] px-2 py-1 text-center text-[#1B7200] rounded-[7.11px] w-max mx-auto mt-[7px] mb-5">
              {offer?.addedBy?.role}
            </div>
            <div className="py-5 px-7 border-t border-[#E0E2E7]">
              <ul>
                <li className="grid grid-cols-[auto_1fr] gap-[14px] mb-4 justify-start">
                  <span className="bg-[#F0F1F3] rounded-[50%] w-[35.56px] h-[35.56px] flex items-center justify-center">
                    <img src={PRofileID} alt="" className="" />
                  </span>
                  <div>
                    <h5 className="text-[#667085] text-base mb-2">
                      {t("hotedetailpromotionDetail").userProfile.userId}
                    </h5>
                    <p className="text-[#353535] text-base">
                      {offer?.addedBy?._id}
                    </p>
                  </div>
                </li>
                <li className="grid grid-cols-[auto_1fr] gap-[14px] mb-4 justify-start">
                  <span className="bg-[#F0F1F3] rounded-[50%] w-[35.56px] h-[35.56px] flex items-center justify-center">
                    <TbMailFilled className="text-[#667085] text-base" />
                  </span>
                  <div>
                    <h5 className="text-[#667085] text-base mb-2">
                      {t("hotedetailpromotionDetail").userProfile.email}
                    </h5>
                    <p className="text-[#353535] text-base">
                      {offer?.addedBy?.email}
                    </p>
                  </div>
                </li>
                <li className="grid grid-cols-[auto_1fr] gap-[14px] mb-4 justify-start">
                  <span className="bg-[#F0F1F3] rounded-[50%] w-[35.56px] h-[35.56px] flex items-center justify-center">
                    <FaLocationDot className="text-[#667085] text-base" />
                  </span>
                  <div>
                    <h5 className="text-[#667085] text-base mb-2">
                      {t("hotedetailpromotionDetail").userProfile.address}
                    </h5>
                    <p className="text-[#353535] text-base">
                      {offer?.addedBy?.address
                        ? offer?.addedBy?.address
                        : "N/A"}
                    </p>
                  </div>
                </li>
                <li className="grid grid-cols-[auto_1fr] gap-[14px] mb-4 justify-start">
                  <span className="bg-[#F0F1F3] rounded-[50%] w-[35.56px] h-[35.56px] flex items-center justify-center">
                    <img src={Smartphone} alt="" className="" />
                  </span>
                  <div>
                    <h5 className="text-[#667085] text-base mb-2">
                      {t("hotedetailpromotionDetail").userProfile.phoneNumber}
                    </h5>
                    <p className="text-[#667085] text-base">
                      {offer?.addedBy?.phoneNumber
                        ? offer?.addedBy?.phoneNumber
                        : "N/A"}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PromotionDetail;
